import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { RegistrationDocuments } from 'components/RegistrationDocuments/RegistrationDocuments';

export const RegistrationDocumentsPage = () => {
  return (
    <BaseLayout pageTitle={t`Registration documents | Introducer Portal`}>
      <RegistrationDocuments />
    </BaseLayout>
  );
};
